import { handleize } from './util.functions'

export const parseFilterTags = (rawTags = '') => {
  return String(rawTags)
    .split('||')
    .map(tag => tag.trim())
    .filter(Boolean)
}

export const normalizeFilterValue = (value = '') => {
  return handleize(String(value || '').trim())
}

export const deriveProductFilterMeta = ({
  collections = [],
  statuses = [],
  features = [],
} = {}) => {
  const seriesMap = new Map()
  const statusMap = new Map()
  const featureMap = new Map()

  collections.forEach(collection => {
    const label = String(collection || '').trim()
    const value = normalizeFilterValue(label)

    if (label && value && !seriesMap.has(value)) {
      seriesMap.set(value, label)
    }
  })

  statuses.forEach(status => {
    const label = String(status || '').trim()
    const value = normalizeFilterValue(label)

    if (label && value && !statusMap.has(value)) {
      statusMap.set(value, label)
    }
  })

  features.forEach(feature => {
    const label = String(feature || '').trim()
    const value = normalizeFilterValue(label)

    if (label && value && !featureMap.has(value)) {
      featureMap.set(value, label)
    }
  })

  return {
    series: Array.from(seriesMap.entries()).map(([value, label]) => ({ value, label })),
    statuses: Array.from(statusMap.entries()).map(([value, label]) => ({ value, label })),
    features: Array.from(featureMap.entries()).map(([value, label]) => ({ value, label })),
  }
}

export const collectFilterOptions = (items = []) => {
  const series = new Map()
  const statuses = new Map()
  const features = new Map()

  items.forEach(item => {
    ;(item.series || []).forEach(option => {
      if (option.value && option.label && !series.has(option.value)) {
        series.set(option.value, option.label)
      }
    })

    ;(item.statuses || []).forEach(option => {
      if (option.value && option.label && !statuses.has(option.value)) {
        statuses.set(option.value, option.label)
      }
    })

    ;(item.features || []).forEach(option => {
      if (option.value && option.label && !features.has(option.value)) {
        features.set(option.value, option.label)
      }
    })
  })

  const sortOptions = (entries) => {
    return Array.from(entries.entries()).sort((a, b) => a[1].localeCompare(b[1]))
  }

  return {
    series: sortOptions(series),
    statuses: sortOptions(statuses),
    features: sortOptions(features),
  }
}

export const populateFilterSelect = (select, placeholder, options, selectedValue = '') => {
  if (!select) return

  const normalizedSelectedValue = String(selectedValue || '')
  const optionMarkup = options.map(([value, label]) => {
    const selectedAttr = value === normalizedSelectedValue ? ' selected' : ''
    return `<option value="${value}"${selectedAttr}>${label}</option>`
  }).join('')

  select.innerHTML = `<option value="">${placeholder}</option>${optionMarkup}`
}
